import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { getZonedTimeFormatted } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LazyImage from "../common/LazyImage";

export default function EventDetailCard({ container, event }) {
  const coverStyle = event.cover_url
    ? { backgroundImage: `url("${event.cover_url}")` }
    : {};

  return (
    <Card className="event-card h-100 mx-1 mb-3">
      <Link to={`/events/${event.id}/${event.slug}`} className="event-card-link">
        {/* Cover */}
        <div className="event-card-cover" style={coverStyle}>
          {!event.cover_url && (
            <div className="event-card-cover-placeholder">
              <FontAwesomeIcon icon="calendar-days" className="mx-0" />
            </div>
          )}
          <div className="event-card-badges">
            <span className="event-badge">
              <FontAwesomeIcon icon="users" className="mx-0" /> {event.users_attending_count ?? 0}
            </span>
            <span className="event-badge">
              <FontAwesomeIcon icon="building" className="mx-0" /> {event.companies_attending_count ?? 0}
            </span>
          </div>
        </div>

        {/* Content */}
        <CardBody className="d-flex flex-column">
          <div className="event-card-title">{event.title}</div>
          <div className="mt-auto">
            <div className="event-card-detail">
              <FontAwesomeIcon icon="calendar-days" fixedWidth className="text-primary mx-0" />
              <strong>{getZonedTimeFormatted(event.start_date, "PPPP @ p")}</strong>
            </div>
            <div className="event-card-detail">
              <FontAwesomeIcon icon="server" fixedWidth className="text-muted mx-0" />
              <span>{container.localeManager.strings[event.mode]}</span>
            </div>
            <div className="event-card-detail">
              <FontAwesomeIcon icon="gamepad" fixedWidth className="text-muted mx-0" />
              <span>{event.game?.name}</span>
            </div>
            {event.company && (
              <div className="event-card-company">
                <LazyImage
                  src={event.company.avatar_url}
                  className="event-card-company-logo"
                  placeholder="/assets/company-placeholder.png"
                  alt={event.company.name}
                />
                <span>{event.company.name}</span>
              </div>
            )}
          </div>
        </CardBody>
      </Link>
    </Card>
  );
}

